import React from 'react'

import { Button, PremiumBadge } from '@bikemap/components'

import './BasePromotionModal.scss'

/**
 * @typedef {Object} ImgVersions
 * @property {string} jpg
 * @property {string} webp
 * @property {string} avif
 */

/**
 * @param {Object} props
 * @param {string} [props.label]
 * @param {ImgVersions} props.img
 * @param {string} props.imageAlt
 * @param {string} props.title
 * @param {string} props.description
 * @param {string} [props.finePrint]
 * @param {string} props.ctaLink
 * @param {string} props.cta
 * @param {boolean} [props.premium]
 * @param {boolean} [props.black]
 * @param {React.ReactNode} [props.learnMoreLink]
 */
const BasePromotionModal = ({ label, img, imageAlt, title, description, finePrint, ctaLink, cta, premium, black, learnMoreLink }) => (
    <div className='promotions-modal-body-content'>
        {label && <div className='promotions-modal-label'>{label}</div>}
        <div className='heading'>
            <div className='picture-holder'>
                <picture>
                    <source srcSet={img.avif} type='image/avif' />
                    <source srcSet={img.webp} type='image/webp' />
                    <source srcSet={img.jpg} type='image/jpg' />
                    <img src={img.jpg} alt={imageAlt} />
                </picture>
            </div>
            <div className='badge-holder'>
                <PremiumBadge />
            </div>
        </div>
        <div className={'promotions-content' + (black ? ' promotions-content-black' : '')}>
            <h4 className='title'>{title}</h4>
            <div className='description' dangerouslySetInnerHTML={{ __html: description }} />
            <Button variant={premium ? 'success' : 'primary'} size='action' width='block' href={ctaLink} className='cta-button'>{cta}</Button>
            {finePrint && (
                <div className='fine-print'>
                    <small className='text-secondary'>{finePrint} {learnMoreLink}</small>
                </div>
            )}
        </div>
    </div>
)

export default BasePromotionModal
